import React from "react";

import { templates } from "@reactivated";

import { ProductSelectionGridSSR } from "../apps/product-compare/ProductSelectionGridSSR";

export const Template = (
    props: templates.ProductSelectionGridBlockTemplate,
): React.JSX.Element => <ProductSelectionGridSSR {...props} />;
